export default __webpack_public_path__ + "static/media/family.0f64c8b4.png";